import { WindowKeys, WindowManagement } from "./windowManagement";

export enum HookKeys {
    ADD_TO_WISHLIST = "ADD_TO_WISHLIST",
}

export default class HooksService {
    private static registery: { [key: string]: (() => void)[] } = {};

    static register(key: HookKeys, callback: () => void) {
        this.registery[key] ||= [];
        this.registery[key].push(callback);
    }

    static hasCallbacksFor(key: HookKeys) {
        const cbs = this.registery[key] || [];
        return cbs.length > 0;
    }

    static triggerCallback(key: HookKeys) {
        this.getCallbacksFor(key).forEach(callback => callback());
    }

    static getCallbacksFor(key: HookKeys): (() => void)[] {
        if (!this.hasCallbacksFor(key)) {
            return [];
        }
        return this.registery[key];
    }
}

const init = () => {
    WindowManagement.saveObject(WindowKeys.HOOKS, HooksService);
};

export { init };
